import { addSentryBreadcrumb } from "../hooks/useConfigureSentry";
import { httpClient } from "@coworker/http-client";

export async function updateUser(uid, user) {
  if (!uid || !user) {
    addSentryBreadcrumb({
      category: "user-update",
      message: "updateUser called with empty uid or user object",
      level: "warning",
      data: { uid, user },
    });
    return;
  }
  const userCopy = { ...user, uid };
  if (userCopy.team_id) userCopy["teamId"] = userCopy.team_id;
  if (typeof userCopy.phone !== "undefined")
    userCopy["phoneNumber"] = userCopy.phone;

  return await httpClient.core.put(`/users/${uid}`, { body: userCopy });
}
